export default "__VITE_ASSET__3e0960d7__"